@if (course) {
  @if (!isMobileView) {
    <section class="card course-card">
      <div class="card-image-badge">
        <div (click)="openCourseDetailDialog()" class="card-image background-loading cursor-pointer">
          <img [src]="course.imageUrl" alt="" appDefaultImage="assets/images/defaults/course.png" />
        </div>

        <app-badge [type]="'gradient'" borderRadius="6px" positionLeft="12px" positionTop="10px" [text]="instructorType | translate"></app-badge>
      </div>

      <div class="card-content">
        <h2 (click)="openCourseDetailDialog()" class="card-title">{{ course.name }}</h2>
        <div class="card-date">
          <app-icon iconName="calendar" size="16px"></app-icon>
          <p class="date-range">{{ course.currentDate | friendlyDate: true : true }}</p>
        </div>

        <div class="card-time">
          <app-icon iconName="clock" size="16px"></app-icon>
          <p class="time-range">
            {{ course.startTime }} - {{ course.endTime }}
            <span translate>Clock</span>
          </p>
        </div>

        <div class="card-location">
          <app-icon iconName="marker" size="16px"></app-icon>
          <p class="location">{{ course.place }}</p>
        </div>

        <div class="participants">
          <div class="participant-avatar">
            @if (course.courseUsers.length > 3) {
              <div class="participant-count-badge">+{{ course.courseUsers.length - 3 }}</div>
            }
            @for (user of course.courseUsers | slice: 0 : 3; track user.id) {
              <a class="avatar-image" [tippy]="user?.users?.fullName">
                <img [appFetchProfileImage]="user?.users?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
              </a>
            }
          </div>
        </div>

        <div class="prices-seats">
          <div class="price-info">
            @if (course.pricePerParticipant) {
              <span class="discounted-price">{{ +course.pricePerParticipant ? '€ ' + course.pricePerParticipant : ('Free' | translate) }}</span>
            }
            <!-- <del class="original-price">$50</del> -->
          </div>
          @if (isCourseFullyBooked) {
            <span class="tag" translate>Booked Out</span>
          } @else {
            <span class="tag">{{ ('Occupancy' | translate) + ':' + (availabilityCount || 0) + '/' + course.allowedPersons }}</span>
          }
        </div>

        <div class="join-btn">
          @if (availableToJoin) {
            @if (isCourseFullyBooked) {
              <app-button [idleText]="'Booked out' | translate" cssClass="button-simple button-full" disabled="true" size="small"></app-button>
            } @else {
              <app-button (click)="join()" [idleText]="'courses.join course' | translate" cssClass="button-primary button-full" size="small"></app-button>
            }
          } @else {
            <app-button [idleText]="courseUserStatus | translate" cssClass="button-simple button-full" disabled="true" size="small"></app-button>
          }

          @if (isOwner || isUserAdmin) {
            <div [tippy]="'nav.more' | translate" class="button">
              <button [data]="course" [tippy]="menu" class="button button-simple button-icon-only button-small" className="popper-menu" placement="bottom-start" variation="popper">
                <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="v-ellipsis" size="20px"></app-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </section>
  } @else {
    <ng-container *ngTemplateOutlet="mobileCard"></ng-container>
  }
}

<ng-template #mobileCard>
  <section class="card m-course-card">
    <div [queryParams]="{ currentDate: course.currentDate }" [routerLink]="[course.id, 'details']" class="card-image background-loading">
      <img [src]="course.imageUrl" alt="" appDefaultImage="assets/images/defaults/course.png" />
      <app-badge [text]="instructorType | translate" [type]="'gradient'" borderRadius="6px" positionLeft="12px" positionTop="10px"></app-badge>
    </div>

    <div class="card-content">
      <h2 [queryParams]="{ currentDate: course.currentDate }" [routerLink]="[course.id, 'details']" class="card-title">{{ course.name }}</h2>

      <div class="participants-action">
        @if (course?.courseUsers && course?.courseUsers?.length) {
          <div class="participants mt-0">
            <div class="participant-avatar background-loading-tiny">
              @if (course.courseUsers.length > 3) {
                <div class="participant-count-badge">+{{ course.courseUsers.length - 3 }}</div>
              }
              @for (user of course.courseUsers | slice: 0 : 3; track user.id) {
                <a class="avatar-image">
                  <img [appFetchProfileImage]="user?.users?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
                </a>
              }
            </div>
          </div>
        }

        <div class="flex-row-center-center gap-6 ml-auto">
          @if (availableToJoin) {
            <app-button
              (click)="join()"
              [idleText]="'courses.join course' | translate"
              [inlineStyle]="{ 'font-weight': '600' }"
              cssClass="button-outline-primary"
              iconColor="var(--white)"
              size="small"
              width="100%"
            ></app-button>
          }

          <!--          @if (!availableToJoin) {-->
          <!--          <app-button-->
          <!--            [idleText]="courseUserStatus | translate"-->
          <!--            [inlineStyle]="{ 'font-weight': '600' }"-->
          <!--            cssClass="button-outline-primary"-->
          <!--            disabled="true"-->
          <!--            iconColor="var(&#45;&#45;white)"-->
          <!--            size="small"-->
          <!--            width="100%"-->
          <!--          ></app-button>-->
          <!--          }-->

          @if (isOwner || isUserAdmin) {
            <div [tippy]="'nav.more' | translate" class="button">
              <button
                [data]="course"
                [tippy]="menu"
                class="button button-simple button-icon-only button-outline-primary button-small"
                className="popper-menu"
                placement="bottom-start"
                variation="popper"
              >
                <app-icon [cssStyle]="{ marginTop: '-2px' }" color="var(--orange)" iconName="v-ellipsis" size="20px"></app-icon>
              </button>
            </div>
          }
        </div>
      </div>

      <div class="date-time">
        <div class="card-date">
          <app-icon iconName="clock" size="20px"></app-icon>
          <p>{{ course.currentDate | friendlyDate: true : true }}</p>
        </div>

        <div class="card-time">
          <app-icon iconName="calendar" size="20px"></app-icon>
          <p>
            {{ course.startTime }} - {{ course.endTime }}
            <span translate>Clock</span>
          </p>
        </div>
      </div>

      <div class="card-location">
        <app-icon iconName="marker" size="20px"></app-icon>
        <p>{{ course.place }}</p>
      </div>

      <div class="prices">
        @if (course.pricePerParticipant) {
          <span class="discounted-price">{{ +course.pricePerParticipant ? '€ ' + course.pricePerParticipant : ('Free' | translate) }}</span>
        }
        <!--        <del class="original-price">$50</del>-->
      </div>
    </div>
  </section>
</ng-template>

<ng-template #menu let-data="data" let-hide>
  <!-- This menu-content is generic class can be override with custom style as well, adjust width value directly as per need -->
  <div class="popper-menu-content" style="width: 150px">
    <ul>
      <li (click)="edit(data); hide()">
        <app-icon iconName="edit"></app-icon>
        <label translate> community.edit </label>
      </li>
      <li (click)="delete(data); hide()">
        <app-icon iconName="trash"></app-icon>
        <label translate> community.delete </label>
      </li>
    </ul>
  </div>
</ng-template>
